<mat-card>
  <mat-card-content>
    <div class="search-form">
      <mat-form-field color="accent">
        <mat-label>From</mat-label>
        <input matInput [matDatepicker]="matDateFrom" [(ngModel)]="dateFrom" name="dateFrom">
        <mat-datepicker-toggle matSuffix [for]="matDateFrom"></mat-datepicker-toggle>
        <mat-datepicker #matDateFrom></mat-datepicker>
      </mat-form-field>

      <mat-form-field color="accent">
        <mat-label>To</mat-label>
        <input matInput [matDatepicker]="matDateTo" [(ngModel)]="dateTo" name="dateTo">
        <mat-datepicker-toggle matSuffix [for]="matDateTo"></mat-datepicker-toggle>
        <mat-datepicker #matDateTo></mat-datepicker>
      </mat-form-field>

      <!-- <mat-form-field>
        <mat-label>SituProduct</mat-label>
        <mat-select [(value)]="product">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let item of products" [value]="item">
            <div fxLayout="row" fxLayoutAlign="start center">
              <div class="m-r-10 chart-select-color" [style.background-color]="item.productColor"></div><div>{{item.product}}</div>
            </div>
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <!-- <mat-form-field>
        <mat-label>Manufacturer</mat-label>
        <mat-select [(value)]="manufacturer" name="manufacturer">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let manufacturerItem of manufacturers" [value]="manufacturerItem">
            {{ manufacturerItem }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->

      <div fxLayout="row" fxLayoutGap="15px">
        <button mat-button type="submit" mat-flat-button color="primary" (click)="loadData()">
          <mat-icon>search</mat-icon> Search
        </button>
        <button type="submit" mat-flat-button [color]="buttonHighlight('perProduct')" (click)="perProduct()">Per
          Product</button>
        <button type="submit" mat-flat-button [color]="buttonHighlight('perManufacturer')" (click)="perManufacturer()">Per
          Manufacturer</button>
        <button mat-button type="submit" mat-flat-button color="primary" (click)="downloadCsv()" *ngIf="showCsvButton()">
          <mat-icon>file_download</mat-icon> Save as CSV
        </button>
        <button type="submit" color="primary" mat-flat-button (click)="downloadDailyCsv()">
          <mat-icon>file_download</mat-icon> Generate By-Day Report
        </button>
      </div>
    </div>
  </mat-card-content>
</mat-card>
<mat-card>
  <table mat-table class="no-hover-highlight" [dataSource]="productImpressions" fxFill>
    <ng-container matColumnDef="sessionId">
      <th mat-header-cell *matHeaderCellDef> SessionId </th>
      <td mat-cell *matCellDef="let item"> {{item.sessionId}} </td>
    </ng-container>

    <ng-container matColumnDef="manufacturer">
      <th mat-header-cell *matHeaderCellDef> Manufacturer </th>
      <td mat-cell *matCellDef="let item"> {{item.manufacturer}} </td>
    </ng-container>

    <ng-container matColumnDef="productId">
      <th mat-header-cell *matHeaderCellDef> Product ID </th>
      <td mat-cell *matCellDef="let item"> {{item.productId}} </td>
    </ng-container>

    <ng-container matColumnDef="productName">
      <th mat-header-cell *matHeaderCellDef> Product Name </th>
      <td mat-cell *matCellDef="let item"> {{item.productName}} </td>
    </ng-container>

    <ng-container matColumnDef="builder">
      <th mat-header-cell *matHeaderCellDef> Builder </th>
      <td mat-cell *matCellDef="let item"> {{item.builder}} </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef> Action </th>
      <td mat-cell *matCellDef="let item"> {{item.action}} </td>
    </ng-container>

    <ng-container matColumnDef="home">
      <th mat-header-cell *matHeaderCellDef> Home </th>
      <td mat-cell *matCellDef="let item"> {{item.home}} </td>
    </ng-container>

    <ng-container matColumnDef="masterFile">
      <th mat-header-cell *matHeaderCellDef> MasterFile </th>
      <td mat-cell *matCellDef="let item"> {{item.masterFile}} </td>
    </ng-container>

    <ng-container matColumnDef="room">
      <th mat-header-cell *matHeaderCellDef> Room </th>
      <td mat-cell *matCellDef="let item"> {{item.room}} </td>
    </ng-container>

    <ng-container matColumnDef="dateTimeStamp">
      <th mat-header-cell *matHeaderCellDef> Time </th>
      <td mat-cell *matCellDef="let item"> {{item.dateTimeStamp | date:'short'}} </td>
    </ng-container>

    <ng-container matColumnDef="totalImpressions">
      <th mat-header-cell *matHeaderCellDef> Total Impressions </th>
      <td mat-cell *matCellDef="let item"> {{item.totalImpressions}} </td>
    </ng-container>

    <ng-container matColumnDef="billableImpressions">
      <th mat-header-cell *matHeaderCellDef> Billable Impressions </th>
      <td mat-cell *matCellDef="let item"> {{item.billableImpressions}} </td>
    </ng-container>

    <ng-container matColumnDef="manufacturerDetail">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <button type="submit" mat-raised-button (click)="downloadManufacturerDetail(item.manufacturer)">Save as CSV</button>
          </td>
    </ng-container>
    
    <ng-container matColumnDef="view">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <div fxLayout="row" fxLayoutAlign="end center">
          <button color="accent" mat-icon-button matTooltip="Edit Product" (click)="openProductInNewWindow($event, item);"><mat-icon>kitchen</mat-icon></button>
          <button color="accent" mat-icon-button matTooltip="view situLINK" (click)="openSituLinkInNewWindow($event, item.artifactId, false);"><mat-icon>share</mat-icon></button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="[25, 50, 100]"
    (page)="onPageChange($event)">
  </mat-paginator>
</mat-card>
